import type { TVariableProps } from "@/dialogs/share-dialog/types";

export interface DataPair {
  key: string;
  value: string;
}

export const createListRecord = (
  children: TVariableProps[],
): Record<string, unknown> =>
  Object.fromEntries(
    children.map((child) => [child.name, child.default ?? ""]),
  );

export const recordToPairs = (record: Record<string, unknown>): DataPair[] =>
  Object.entries(record).map(([key, value]) => ({
    key,
    value: String(value ?? ""),
  }));

export const pairsToRecord = (pairs: DataPair[]): Record<string, string> =>
  Object.fromEntries(
    pairs.map(({ key, value }) => [key.trim(), value] as const),
  );
